import { Navigate, useParams } from 'react-router-dom';

export function QuotationProductCreatePage() {
  const { quotationId } = useParams();
  return (
    <Navigate to={`/quotations/${quotationId}?action=create-product`} replace />
  );
}

export default QuotationProductCreatePage;
